/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PostMerchantRootAdminUserRequest } from '../../models/post-merchant-root-admin-user-request';
import { User } from '../../models/user';

export interface RegisterMerchantRootUser$Params {
      body: PostMerchantRootAdminUserRequest
}

export function registerMerchantRootUser(http: HttpClient, rootUrl: string, params: RegisterMerchantRootUser$Params, context?: HttpContext): Observable<StrictHttpResponse<User>> {
  const rb = new RequestBuilder(rootUrl, registerMerchantRootUser.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<User>;
    })
  );
}

registerMerchantRootUser.PATH = '/users/merchant-root-admin-users';
